module.exports = __webpack_public_path__ + "img/rank_top_bg_4_en.e1699b4e.png";